import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_ux",
  "use": "svg_ux-usage",
  "viewBox": "0 0 22 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 16\" id=\"svg_ux\"><path d=\"M1 2v7.75A4.25 4.25 0 0 0 5.25 14v0A4.25 4.25 0 0 0 9.5 9.75V2M12 2l8.5 12M12 14l8.5-12\" stroke=\"currentColor\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol